import BasePage from "components/basePage/BasePage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "services/helper";
import { getSearchTermByID, getSearchTermDescriptor } from "services/requests";
import { StandardForm } from "wm-standard-crud";
import "./TermForm.scss";

function TermForm() {
  const { id } = useParams();
  const [termInfo, setTermInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [descriptor, setDescriptor] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getSearchTermByID(id).then((data) => setTermInfo(data));
    getSearchTermDescriptor()
      .then((data) => setDescriptor(data))
      .catch(() => {
        showToast(
          "Parece que não foi possível buscar as informações, tente novamente mais tarde.",
          "error"
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <BasePage
      title={termInfo?.term ? `${termInfo?.term}` : "Detalhes do termo"}
      loading={loading}
      className="term-details-screen"
    >
      {id && (
        <p id="created-at">
          <span>
            <strong>Data de criação:</strong>
          </span>
          {moment(termInfo?.createdAt).format("DD/MM/YYYY - HH:mm")}
        </p>
      )}
      <StandardForm
        descriptor={descriptor}
        id={parseInt(id)}
        onSave={() => {
          showToast("Novo termo salvo com sucesso.", "success");
          navigate(-1); //It goes back to earlier page
        }}
        onError={() => showToast("Não foi possível salvar o Termo .", "error")}
      />
    </BasePage>
  );
}

export default TermForm;
